import React, { useState } from 'react'

import { css } from '@emotion/core'

import SectionContainer from 'components/layouts/atoms/SectionContainer'
import Container from 'components/layouts/atoms/Container'
import Markdown from 'components/common/atoms/MarkdownContent'
import Typography from 'components/common/atoms/Typography'
import FAQ from 'components/common/molecules/FAQ'

import KoinworksFAQData from './KoinworksFAQData.json'

const KoinworksFAQ = () => {
  const initialState = () =>
    KoinworksFAQData.map((faq, idx) => ({
      ...faq,
      active: idx === 0,
      id: idx,
      answer: <Markdown content={faq.answer} className="faq__answer" />,
    }))
  const [faqs, setFaqs] = useState(initialState())

  const toggleAnswer = (id: number) => {
    const newFaqs = faqs.map((faq) => (faq.id === id ? { ...faq, active: !faq.active } : { ...faq, active: false }))
    setFaqs(newFaqs)
  }

  return (
    <div className="koinworks-faq">
      <SectionContainer withPaddingBottom>
        <Container>
          <Typography
            variant="title"
            level="2"
            tagName="h2"
            fontWeight="bold"
            css={css`
              margin-bottom: 24px;
              line-height: 1.5;
              @media screen and (min-width: 768px) {
                text-align: center;
                margin-bottom: 40px;
              }
            `}
          >
            Frequently Asked Questions
          </Typography>
          {faqs.map((faq, idx) => (
            <FAQ
              key={`faq-item-${idx}`}
              question={faq.question}
              answer={faq.answer}
              active={faq.active}
              onClick={() => toggleAnswer(faq.id)}
            />
          ))}
        </Container>
      </SectionContainer>
    </div>
  )
}

export default KoinworksFAQ
